export default class FeaturedEventChooser {
  constructor(rawEvents, number, excludeIds = []) {
    this.events = rawEvents.filter((e) => !excludeIds.includes(e.objectID));
    this.number = number;
  }

  /* returns an integer score out of 270 for the event */
  weight(event) {
    const oneDay = 24 * 60 * 60;
    const featuredTimeSpanInSeconds = process.env.FEATURED_TIME_SPAN * oneDay;
    let secondsPromotedFor = Math.min(
      event.end_time_i - event.created_time_i,
      featuredTimeSpanInSeconds
    );
    if (secondsPromotedFor < oneDay) {
      secondsPromotedFor = oneDay;
    }

    return Math.floor((featuredTimeSpanInSeconds * 3) / secondsPromotedFor);
  }

  randomWeightedEvents() {
    /*
      We want to randomly choose a selection, but weight how we choose by how long
      the event will be featured for (which is end_time_i - created_time_i),
      This should mean each event gets the same amount of featured spot impressions,
      regardless of how long it is promoted for
    */

    const weightedArray = [].concat(
      ...this.events.map((event) => Array(this.weight(event)).fill(event))
    );
    let result = [],
      index = 0;

    // Limit loop to 1000 iterations just in case.
    while (result.length < this.number && index < 1000) {
      index += 1;
      const pickedEvent = weightedArray[Math.floor(Math.random() * weightedArray.length)];
      if (!result.includes(pickedEvent)) {
        result.push(pickedEvent);
      }
    }

    return result;
  }

  choose() {
    let chosenEvents;

    if (this.events.length <= this.number) {
      chosenEvents = this.events;
    } else {
      chosenEvents = this.randomWeightedEvents();
    }

    return this.randomSort(chosenEvents);
  }

  randomSort(events) {
    return events.sort(() => 0.5 - Math.random());
  }

  chooseMore(currentFeaturedEvents) {
    const currentFeaturedEventIds = currentFeaturedEvents.map((e) => e.objectID);
    let additonalEvents = this.randomWeightedEvents().filter(
      (e) => currentFeaturedEventIds.indexOf(e.objectID) === -1
    );
    return currentFeaturedEvents.concat(additonalEvents);
  }
}
